import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import InputAdornment from "@material-ui/core/InputAdornment";
import CustomValidatedInput from "components/CustomValidatedInput/CustomValidatedInput.jsx";
class ValidatedCustomInput extends React.Component {

    render() {
			const {placeholder, id, required, type, icon, meta, readOnly, disabled, input:{onChange, value, min}} = this.props

			return (
				<div>
					<CustomValidatedInput
						labelText={< span > {placeholder} {(required ? <small> *</small>: '')} </span>}
						id={id}
						meta={meta}
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange:	onChange,
							readOnly:	readOnly,
							disabled:	disabled,
							min: min,
							value: value,
							type: type,
							endAdornment: (icon
								? <InputAdornment position="end" className={this.props.classes.inputAdornment}>
										{icon}
									</InputAdornment>
								: '')
							}
						}/>
						
				</div>
				
      )  
    }
}

ValidatedCustomInput.propTypes = {
		placeholder: PropTypes.string.isRequired,
};

export default withStyles(styles)(ValidatedCustomInput)


// WEBPACK FOOTER //
// ./src/views/Components/ValidatedCustomInput.jsx